import { supabase } from '@/integrations/supabase/client';
import { EMAIL_TEMPLATES, EmailType } from './mailTemplates';

export async function sendTransactionalEmail(
  emailType: EmailType,
  recipientEmail: string,
  recipientName: string,
  templateVars: Record<string, any> = {}
) {
  try {
    const template = EMAIL_TEMPLATES[emailType](templateVars);

    const { data, error } = await supabase.functions.invoke('send-transactional-email', {
      body: {
        to: recipientEmail,
        toName: recipientName,
        emailType,
        templateVars: template,
      },
    });

    if (error) throw error;

    console.log(`[Email Service] ✅ ${emailType} sent to ${recipientEmail}`);
    return { success: true, data };
  } catch (error) {
    console.error(`[Email Service] ❌ Failed to send ${emailType}:`, error);
    return { success: false, error };
  }
}
